import React from 'react'
import PrimaryButtonWithIconAdd from '../../../components/ui/PrimaryButtonWithIconAdd'
import Layout from '../../../components/layouts/Layout'
import { useTranslation } from 'react-i18next'
import { useCarBrandsByAdmin } from '../../../hooks/admin/carBrand.admin';
import LoadingErrorState from '../../../components/ui/LoadingErrorState';
import EmptyData from '../../../components/ui/EmptyData';
import CarBrandsTable from '../../../components/admin/carBrand/CarBrandListTable';
import { PermissionGate } from '../../../components/admin/PermissionGate';
import { PermissionsKey } from '../../../data/permissions';

function AdminViewAllCarBrandsPage() {
    const {t} = useTranslation();
    const {isError , isLoading, data:carBrands} = useCarBrandsByAdmin();
  return (
    <Layout title={t('admin_sidebar.car_brand')} headline=''>
         <div className='flex justify-end'>
            <PermissionGate  permissions={[PermissionsKey.CreateCarBrand]}>
              <PrimaryButtonWithIconAdd
              buttonLabel="add_new_car_brand"
              buttonLinkPath="/admin/add-carBrand"
              />
            </PermissionGate>
         </div>
         <LoadingErrorState
         isError={isError}
         isLoading={isLoading}
         />
        {
        carBrands && (
          carBrands.length === 0 ?<EmptyData/> : <CarBrandsTable carBrands={carBrands}/>
        )
        }
    </Layout>
  )
}

export default AdminViewAllCarBrandsPage